import n, { Component as p } from "react";
import e from "prop-types";
import d from "memoize-one";
import { some as f, filter as c, includes as u } from "lodash";
import { f as m } from "./flattenOptions-BNos8vHQ.es.js";
import { S as h, O as b, C as O } from "./index-BRV0FOnC.es.js";
class s extends p {
  // Flatten nested options into 2d array and cache
  flattenOptions = d(m);
  render() {
    const o = this.flattenOptions(this.props.options), t = this.props.selected.map(
      (l) => o.find((a) => a.value === l)
    ), r = f(t, (l) => l === void 0) ? "" : t.map((l) => l.label).join(", "), i = c(
      o,
      (l) => u(this.props.selected, l.value)
    );
    return /* @__PURE__ */ n.createElement(
      h,
      {
        ...this.props,
        selectText: r,
        chipOpts: i
      }
    );
  }
}
s.propTypes = {
  /** The selectable options. See Option and Category objects below for details on possible keys/values. */
  options: e.arrayOf(
    e.oneOfType([
      b.isRequired,
      O.isRequired
    ])
  ),
  /** The array of currently selected option values  */
  selected: e.arrayOf(e.string.isRequired).isRequired,
  /** When true, text '(required)' will appear next to the label */
  required: e.bool,
  /** Called when the expanded state should be changed to given boolean value */
  onExpand: e.func,
  /** Function called with new `selected` values when they change due to user interaction */
  onSelect: e.func.isRequired,
  /** The label text shown above the Select.<br/>
   * <b>Required if `props.ariaLabelledBy` is not defined</b>
   * */
  label: e.string,
  /** Set to true to disable interaction with the select */
  disabled: e.bool,
  /** Set to true to allow selection of multiple options */
  multiple: e.bool,
  /** When true, select will be displayed with 'dark' mode. */
  dark: e.bool,
  /** If true and multiple is true, chips will be displayed below the select for each selected option. */
  showChips: e.bool,
  /** An object to pass in text translations, and generate translations.
   * See below for the full object of strings with defaults.
   * */
  alternateText: e.objectOf(e.string),
  /** Set to true to make dropdowns show all options without scrolling. */
  dropdownShowAll: e.bool,
  /** Set to true to highlight the select box when one of the dropdown options is selected. */
  highlightWhenOptionSelected: e.bool,
  /** the 'id' property to be passed to the select */
  id: e.string,
  /** HTML id of corresponding description for accessibility */
  ariaDescribedBy: e.string,
  /** HTML id of corresponding label for accessibility.<br/>
   * <b>Required if `props.label` is not defined</b> */
  ariaLabelledBy: e.string,
  /** When this is specified, the select renders with a red outline and displays this string in an error footer to prompt the user to correct the input. */
  error: e.string
};
s.defaultProps = {
  options: [],
  required: !1,
  onExpand: () => null,
  label: null,
  disabled: !1,
  multiple: !1,
  dark: !1,
  showChips: !1,
  alternateText: {},
  dropdownShowAll: !1,
  highlightWhenOptionSelected: !1,
  id: null,
  ariaDescribedBy: null,
  ariaLabelledBy: null,
  error: null
};
export {
  s as S
};
